import React from 'react';

const SvgTj = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="TJ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="TJ_svg__b" fill="#fff">
        <use xlinkHref="#TJ_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#D9101C" mask="url(#TJ_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#0F7811" mask="url(#TJ_svg__b)" d="M0 13.333h28V20H0z" />
      <path
        d="M13.421 10.667a4.354 4.354 0 0 1-.088-.667.667.667 0 0 1 1.334 0c0 .12-.032.377-.088.667h.76a.667.667 0 0 1 0 1.333h-2.678a.667.667 0 0 1 0-1.333h.76zm-.754-1.334a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zm2.666 0a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zM18 10.667a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zm-8 0a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334z"
        fill="#FAD14E"
        mask="url(#TJ_svg__b)"
      />
    </g>
  </svg>
);

export default SvgTj;
